// ----------------------------------------------------------------------

const account = {
  displayName: "Liam Callahan",
  email: "liam@uniquevisitors.com",
  photoURL: "/static/avatar.jpg",
};

export default account;
